module.exports = __webpack_public_path__ + "img/25.71bdd6ed.png";